import React, { useState } from 'react'
import './services.css'
import {services} from './data.js'


const Services = () => {
    const[clicked, setClicked] = useState(-1)
    const expendHandler = ((index)=>{
        if (clicked === index){
            setClicked(-1)
        }
        else{
            setClicked(index)
        }
        console.log(clicked);
    })

  return (
    <section className='services' id='services'>
      <div className="services-container container">
        <div className="services-wrapper">
           <div className="section-title">
                Services
            </div>
            <div className="services-content">
                {services.map((service, index)=>(
                     <div className='service' key={index} onClick={() => expendHandler(index)}>
                        <div className="service-number" style={{color: `${service.color}`}}>{service.number}</div>
                        <div className="service-header">{service.header}</div>
                        <div className="service-expend">+</div>
                        <div className= {`service-content ${clicked === index ? 'expended' : 'closed'}`}>{service.content} </div>
                     </div>
                ))}
            </div>
        </div>
      </div>
    </section>
  )
}

export default Services
